module.exports = __webpack_public_path__ + "img/phl.12f36eed.svg";